import {
  SET_STEP,
  SET_PASSWORD,
  SET_ACCOUNT,
  SET_SHOW_PRIVATEKEY,
  SET_CONFIRM_MNEMONIC,
  SET_SHOW_KEYSTORE_TEXT,
  SET_RANDOM_WORDS,
} from './action'

import { isGoogleUnlockEnabled } from '../../utils/isGoogleUnlockEnabled'

const initialState = {
  password: '',
  address: '',
  privateKey: '',
  keyStore: '',
  step: isGoogleUnlockEnabled ? 'chooseMethod' : 'inputPassword',
  mnemonic: '',
  randomWords: [],
  keyStoreText: '',
  showPrivateKey: false,
  confirmMnemonic: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSWORD:
      return {
        ...state,
        password: action.password,
      }

    case SET_STEP:
      return {
        ...state,
        step: action.step,
      }

    case SET_SHOW_KEYSTORE_TEXT:
      return {
        ...state,
        ...action.data,
      }

    case SET_ACCOUNT:
      return {
        ...state,
        ...action.data,
      }

    case SET_RANDOM_WORDS:
      return {
        ...state,
        ...action.data,
      }

    case SET_SHOW_PRIVATEKEY:
      return {
        ...state,
        showPrivateKey: action.data,
      }

    case SET_CONFIRM_MNEMONIC:
      return {
        ...state,
        confirmMnemonic: action.data,
      }

    default:
      return state
  }
}
